import Aos from '../components/aos'
import React from "react"
import { createRoot } from "react-dom/client";
import NewsCard from "../components/Cards/NewsCard";
import MobileSlider from "../components/Sliders/MobileSlider"

/**
 * News/Journal/Stories Page
 */

const renderNewsCards = () => {

	const recentNewsCardElements = document.getElementsByClassName(
		"js-recent-news-card"
	);

	Array.from(recentNewsCardElements).forEach((card) => {
		const recentNewsCardRoot = createRoot(card);
		recentNewsCardRoot.render(<NewsCard {...card.dataset} />);
	});

}

const PageNews =( $ )=>{

	Aos();
	renderNewsCards();
	MobileSlider($);
};

export default PageNews;
